import React from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { Breadcrumb, message, Spin } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import UserForm from './UserForm';
import { useMutation, useQuery } from '@apollo/client';
import { GET_USERS, UPDATE_USER } from '../../../gql/users';

const EditUser = () => {
  const history = useHistory();
  const { id } = useParams();
  const { data, loading } = useQuery(GET_USERS, { variables: { ids: [id] } });
  const [editUser] = useMutation(UPDATE_USER, {
    refetchQueries: [{ query: GET_USERS, variables: { state: 'ALL' } }],
    onCompleted: ({ updateUser }) => {
      history.push('/system-setting/users');
      message.success(`${updateUser.netId} successfully added`);
    },
    onError: (err) => {
      console.log(err);
    },
  });

  if (loading) {
    return (
      <PageContainer
        header={{
          title: 'Edit User',
        }}
        loading
      />
    );
  }

  const user = data.users[0];

  return (
    <PageContainer
      header={{
        title: 'Edit User',
        breadcrumb: (
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/system-setting/users">User</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {user.name} ({user.netId})
            </Breadcrumb.Item>
          </Breadcrumb>
        ),
      }}
    >
      <Spin spinning={loading} tip="Editing...">
        <UserForm
          initialValues={{
            faculty: user.faculty?.id,
            department: user.department?.id,
            name: user.name,
            email: user.email,
            title: user?.title,
            authenticationMode: user.authenticationMode,
            netId: user.netId,
            active: !user.disabled,
            roles: user.roles.map(({ role, faculty, department }) => ({
              role: role.id,
              faculty: faculty ? faculty.id : undefined,
              department: department ? department.id : undefined,
            })),
          }}
          onFinish={({
            netId,
            faculty,
            department,
            name,
            title,
            active,
            email,
            roles,
          }) => {
            editUser({
              variables: {
                updateUserInput: {
                  id,
                  netId,
                  name,
                  email,
                  title,
                  faculty,
                  department,
                  disabled: !active,
                  deleted: false,
                  roles: roles || [],
                },
              },
            });
          }}
          isEdit={true}
        />
      </Spin>
    </PageContainer>
  );
};

export default EditUser;
